




















import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import {Action, Getter, Mutation} from 'vuex-class';
import {LoadingState, NotificationBanner} from '@/types';
import Spinner from './components/Spinner.vue';
import Toast from './components/Toast.vue';
import EventBus from './services/eventbus.service';
import UpdateSnackbar from '@/components/UpdateSnackbar.vue';
import ClipboardSnackbar from '@/components/ClipboardSnackbar.vue';
import NotificationBannerToast from '@/components/NotificationBannerToast.vue';
import NotificationBannerService from './services/notification.banner.service';

@Component({
  components: {
    NotificationBannerToast,
    ClipboardSnackbar,
    Spinner,
    Toast,
    UpdateSnackbar,
  },
})
export default class App extends Vue {
  @Getter private loading!: LoadingState;
  @Getter private toastErrorMessages!: {[id: string]: string};
  @Getter private notificationBanner!: NotificationBanner | null;
  @Getter private dismissedBanners!: any;
  @Mutation private removeToastErrorMessage: any;

  private forceUpdateKey: number = 0;

  private snackbarOpened: boolean = false;
  private snackbarText: string = '';
  private snackbarIcon: string = '';


  private created() {
    EventBus.$on('global-orgproj-change', this.setForceUpdateKey);
    EventBus.$on('global-account-change', this.setForceUpdateKey);
    EventBus.$on('showGenericSnackbar', this.showGenericSnackbar);
  }

  private destroyed() {
    EventBus.$off('global-orgproj-change', this.setForceUpdateKey);
    EventBus.$off('global-account-change', this.setForceUpdateKey);
    EventBus.$off('showGenericSnackbar', () => { this.snackbarOpened = false; });
  }

  private showGenericSnackbar(details: any) {
    this.snackbarOpened = true;
    this.snackbarText = details.text;
    this.snackbarIcon = details.icon;
    setTimeout(() => {
      this.snackbarOpened = false;
    }, 5000);
  }

  private checkRemoveNotification(show: boolean, key: string): void {
    if (!show) {
      this.removeToastErrorMessage(key);
      // Vue reactivity is a little funky with the store object
      // although inner component is hidden the list element remains
      // within the DOM and in the Vue component list until next render.
      // Here we force an update on the v-for parent component.
      (this.$refs[key] as any)[0].$parent.$forceUpdate();
    }
  }

  private setForceUpdateKey(params: {type: string, id: number, forceRender: boolean} | null) {
    if (this.$router.currentRoute.name !== 'login' && (!params || params.forceRender)) {
      if (this.forceUpdateKey >= 1000) {
        this.forceUpdateKey = 0;
      } else {
        this.forceUpdateKey++;
      }
    }
  }

  private get showBanner() {
    return !!this.notificationBanner && ((this.dismissedBanners && this.dismissedBanners.length && !this.dismissedBanners.includes(this.notificationBanner.id)) || !this.dismissedBanners.length);
  }
}
